// extracted by mini-css-extract-plugin
export default {"status":"Status_status__4i5DO","pending":"Status_pending__QDIdr","completed":"Status_completed__TTmjS","expired":"Status_expired__vQDiN","cancelled":"Status_cancelled__Oo14i"};